import React, { useState } from 'react';
import { TextField, Button, Stack, Typography, Box, Alert } from '@mui/material';

interface LoginProps {
  onLogin: (password: string) => Promise<boolean>;
}

const SimpleAuth: React.FC<LoginProps> = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    const success = await onLogin(password);
    if (!success) {
      setError('Virheellinen salasana');
    }
  };

  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      height="100vh"
      bgcolor="#f5f5f5"
    >
      <Box 
        component="form" 
        onSubmit={handleSubmit} 
        sx={{ 
          padding: 4, 
          borderRadius: 2, 
          boxShadow: 3, 
          backgroundColor: 'white' 
        }}
      >
        <Stack spacing={2} alignItems="center">
          <Typography variant="h5">
            {'Kirjaudu palveluun'}
          </Typography>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="Salasana"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            fullWidth
          />
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {'Kirjaudu'}
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default SimpleAuth;
